import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import Home from "@/pages/Home";
import Align from "@/pages/Align";
import About from "@/pages/About";
import Assessment from "@/pages/Assessment";
import Contact from "@/pages/Contact";
import Process from "@/pages/Process";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Security from "@/pages/Security";
import Admin from "@/pages/Admin";
import EmbedChat from "@/pages/EmbedChat";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import CookieConsent from "@/components/CookieConsent";
import ScrollToTop from "@/components/ScrollToTop";

function Shell() {
  const { pathname } = useLocation();
  const isEmbed = pathname.startsWith("/embed");
  const hideChrome = pathname === "/admin" || isEmbed;

  // Make every wrapper layer transparent for embed pages so the host iframe
  // shows through and no "grey box" appears around the floating chat bubble.
  useEffect(() => {
    if (isEmbed) {
      document.documentElement.classList.add("is-embed");
    } else {
      document.documentElement.classList.remove("is-embed");
    }
  }, [isEmbed]);

  return (
    <>
      <ScrollToTop />
      {!hideChrome && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/align" element={<Align />} />
        <Route path="/about" element={<About />} />
        <Route path="/assessment" element={<Assessment />} />
        <Route path="/process" element={<Process />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/security" element={<Security />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/embed/chat" element={<EmbedChat />} />
      </Routes>
      {!hideChrome && <Footer />}
      {!hideChrome && !isEmbed && <ChatWidget />}
      {!isEmbed && <CookieConsent />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </div>
  );
}

export default App;
